import React, {Component, ReactNode} from 'react'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
  error: Error | null
}

export class BlogErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {hasError: false, error: null}
  }

  static getDerivedStateFromError(error: Error): State {
    return {hasError: true, error}
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Blog error:', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className='container py-10'>
          <div className='alert alert-danger text-center' role='alert'>
            <h4 className='alert-heading'>Something went wrong</h4>
            <p>We're sorry, but there was an error loading the blog content.</p>
            <button
              className='btn btn-advanced-primary mt-3'
              onClick={() => this.setState({hasError: false, error: null})}
            >
              Try Again
            </button>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}
